var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { classMap } from 'lit/directives/class-map.js';
import { html, css } from 'lit';
import { property } from 'lit/decorators.js';
import { PIC, PICBase, doSubmit, customElement, stringDecoder, fetchRestApi, booleanDecoder } from '../Internals';
import { _debounce } from '../../util/Util';
;
let PICNavDrawer = class PICNavDrawer extends PICBase {
    get backBtnItem() {
        if (this.backBtn) {
            return {
                iconClass: 'mdi-keyboard-backspace',
                navText: 'Back',
                navEvent: 'back',
                itemSelected: false,
                isTopLevel: true,
                hovered: false,
                active: false,
                focused: false,
                selectedMenu: false
            };
        }
        return undefined;
    }
    constructor() {
        super();
        // @property({ type: Boolean }) public isPinned: boolean = false;
        this.isVisible = false;
        this.backBtn = false;
        this.debouncedWindowResizeListener = _debounce(() => { this.style.setProperty('--vh', `${window.innerHeight * 0.01}px`); }, 50);
        this.ACTIVE_ITEM = 'activeItem'; // readonly to ensure constant key for session storage
        this.clickedMenuBgColor = false;
        this.activeMenuBgColor = false;
        this.openMenu = false;
        this.closeMenu = false;
        this.data = [ /*
            { iconClass: 'stockIcon', navText: 'Stock Search Yard', navEvent: 'stockSearchYard' },
            { iconClass: 'fa-list', navText: 'Calls', navEvent: 'callList' },
            { iconClass: 'fa-truck', navText: 'Terminal Bookings', navEvent: 'bookList' },
            { iconClass: 'fa-search', navText: 'Find Booking', navEvent: 'booking' },
            { iconClass: 'fa-table', navText: 'Table viewer', navEvent: 'tableView' },
            { iconClass: 'fa-puzzle-piece', navText: 'Components', navEvent: 'showComponents' },
            { iconClass: 'fa-gear', navText: 'Settings', navEvent: 'settings' },*/];
    }
    connectedCallback() {
        super.connectedCallback();
        this.isPicComp_ = false;
        this.style.setProperty('--vh', `${window.innerHeight * 0.01}px`);
        window.addEventListener('resize', this.debouncedWindowResizeListener);
        this.addEventListener('DrawerDataLoaded', this.setUserConfigAndUpdateStyle);
        /* Load config from server */
        PIC.getInstance.userConfig.getData().then(() => {
            this.isVisible = PIC.getInstance.userConfig.isNavDrawerPinned;
            this.requestUpdate();
        });
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedWindowResizeListener);
        this.removeEventListener('DrawerDataLoaded', this.setUserConfigAndUpdateStyle);
        super.disconnectedCallback();
    }
    static get styles() {
        const defaultStyle = css `
            :host{
                z-index: 21;
            }
            .fa-2x {
                font-size: 2em;
            }
            .fa {
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 60px;
                height: 36px;
                font-size: 20px;
            }
            .mdi{
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 60px;
                height: 36px;
                font-size: 20px;
            }
            .slim{
                width: 30px;
            }
            .main-menu{
                z-index: 15;
                /* Light mode keeps the drop shadow; dark mode swaps it for a
                   pale border instead (see --pic-navShadow/--pic-navBorder
                   in webtoolbox.css) - a black shadow barely separates the
                   drawer from an equally-dark page. */
                box-shadow: var(--pic-navShadow, 0px 16px 24px rgba(0, 0, 0, 0.14), 0px 6px 30px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.2));
                border-right: var(--pic-navBorder, none);
                box-sizing: border-box;
                position: relative;
                height: 100vh; /* Fallback for browsers that do not support Custom Properties */
                height: calc(var(--vh, 1vh) * 100);
                width: 60px;
                transition-property: width;
                transition-duration: 0.5s;
                transition-delay: 0.2s;                
                background-color: var(--pic-backgroundColor);
                overflow: hidden;
            }
            .main-menu:hover{
                width: 250px;
            }
            .main-menu.main-menu-expanded {
                width: 250px;
            }
            #navBlocker{
                display: block;
                height: 100%;
                width: 60px;
                transition-property: width;
                transition-duration: 0.5s;
                transition-delay: 0.2s;
                position: fixed;
                top: 0;
                left: 0;
                background-color: var(--pic-onPrimaryDisabledColor);
            }
            #navBlocker.wide{
                width: 250px;
            }
            .lineitem {
                height: 36px;
                color: var(--pic-onSurfaceMediumColor);
                text-align: left;
                cursor: pointer;
                overflow-x: hidden;
                width: 250px;
                position: relative;
                display: grid; 
                grid-template-columns: 60px 160px 30px; 
                grid-template-rows: 1fr; 
                gap: 0px 0px; 
                grid-template-areas: 
                "menuIcons textarea arrow"; 
            }
            .lineitem:hover{
                background-color: var(--pic-primaryActiveColorOpaque);
            }
            .lineitem.hide{
                display: none;
            }
            .menuIcons {
                grid-area: menuIcons;
                justify-self: stretch; 
                align-self: center; 
            }
            .nav-text{
                width: fit-content;
                width: -moz-fit-content;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                height: 100%;
                display: flex;
                align-items: center;
                border-left: 1px solid var(--pic-primaryFocusColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow-y: hidden;
                padding-left: 16px;

                grid-area: textarea;
                justify-self: start; 
                align-self: center;
                user-select: none;
            }
            .openMenu,
            .closeMenu{
                font-style: inherit;
                transition: visibility 250ms, 265ms,  opacity 1s linear;
                width: auto;
                grid-area: arrow;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 100%;
                width: 100%;
            }
            .subMenu {
                background-color: var(--pic-primaryHoverColor);
            }
            .bottomBorder {
                border-bottom: 1px solid var(--pic-primaryFocusColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow-y: hidden;
            }
            .activeBottomBorder {
                border-bottom: 2px solid var(--pic-primaryFocusColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow-y: hidden;
            }
            .markedBottomBorder {
                border-bottom: 4px solid var(--pic-primaryFocusColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow-y: hidden;
            }
            .top_row.lineitem{
                height: 57px;
                align-items: center;
                border-bottom: 1px solid var(--pic-surfaceOverlayActiveColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow-y: hidden;
            }
            .top_row.lineitem:hover {
                background-color: var(--pic-primaryActiveColorOpaque);
            }
            
            .top_row .nav-text{
                width: fit-content;
                width: -moz-fit-content;
                border-left: none;
            }
            .logo_container{
                height: 110px;
                border-top: 1px solid var(--pic-surfaceOverlayActiveColor);
                position: absolute;
                width: 100%;
                bottom: 36px;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 0 2px;
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow: hidden;
            }
            @keyframes grow-shrink {
                40% { transform: scale(1.5); }
                80% { transform: scale(1); }
            }
            .top_buttons{
                height: calc(100% - 202px);
                overflow-y: auto;
                overflow-x: hidden;
            }
            .top_buttons:last-child {
                background-color: pink;
            }
            .menuLine {
                position: fixed;
                width: 1px;
                background-color: var(--pic-primaryFocusColor); 
                left: 61px;
                top: 55px;
                height: calc(100% - 199px);       
            }
            .bottomLine {
                width: 100%;
                height: 1px;
                background-color: var(--pic-primaryFocusColor);
            }
            .activeItemBgColor {
                background-color: var(--pic-primaryActiveColorOpaque); 
            }
            .clickedMenuBgColor {
                background-color: var(--pic-primarySelectedColor);
            }
            .activeMenuBgColor {
                background-color: var(--pic-primaryFocusColor); 
            }
            .bottom_buttons{
                position: absolute;
                width: 100%;
                height: 34px;
                bottom: 0;
                border-top: 1px solid var(--pic-surfaceOverlayActiveColor);
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
                overflow: hidden;
            }
            .bottom_buttons .lineitem .help:not(.main-menu:hover .help, .main-menu.main-menu-expanded .help){
                padding-right: 20px;
                margin-left: -15px;
            }
            .bottom_buttons .lineitem svg path{
                fill: var(--pic-onSurfaceMediumColor);
                fill-opacity: 1;
            }
            .bottom {
                display: flex;
                justify-content: space-evenly;
                cursor: default;
            }
            .bottom:hover {
                background-color: var(--pic-primaryActiveColorOpaque);
            }
            .bottomBtn {
                width: 25%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                cursor: pointer;
                transition-duration: 0.5s;
                transition-delay: 0.2s;
            }
            .pin{
                font-family: "Material Design Icons";
                min-width: 24px;
                width: 24px;
                height: 24px;
                font-style: unset;
            }
            .pin.outlined-pin::before{
                color: var(--pic-onSurfaceMediumColor);
                cursor: pointer;
                content: '\u{F0931}';
                line-height: 24px;
                padding-left: 4px;
            }
            .pin.filled-pin::before{
                color: var(--pic-onSurfaceMediumColor);
                cursor: pointer;
                content: '\u{F0403}';
                line-height: 24px;
                padding-left: 4px;
            }
            
            .picitDots{
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 60px;
                height: 55px;
            }
            .picitDotsBig{
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                width: 100%;
                height: 100%;
            }
            .picitDotsBig svg{
                width: unset;
                height: 70%;
            }
        `;
        return css `
            ${super.styles}
            ${defaultStyle}
        `;
    }
    getMainMenuClass() {
        return {
            'main-menu-expanded': this.isVisible || PIC.getInstance.userConfig.isNavDrawerPinned,
            'main-menu': true,
        };
    }
    getMenuBottomLineClass() {
        return {
            'bottomLine-expanded': this.isVisible || PIC.getInstance.userConfig.isNavDrawerPinned,
            'bottomLine': true
        };
    }
    getPinClass() {
        return {
            displaynone: this.getDispNone(),
            pin: true,
            'outlined-pin': !PIC.getInstance.userConfig.isNavDrawerPinned,
            'filled-pin': PIC.getInstance.userConfig.isNavDrawerPinned,
            slim: true,
        };
    }
    getTextClass() {
        return {
            'nav-text': true,
            displaynone: this.getDispNone(),
            'pic-subtitle2': true,
        };
    }
    getDispNone() {
        return !this.isVisible && !PIC.getInstance.userConfig.isNavDrawerPinned;
    }
    getMenuIconClass(iNavItem) {
        return {
            openMenu: Boolean(!iNavItem.active && iNavItem.subMenu),
            closeMenu: Boolean(iNavItem.active && iNavItem.subMenu),
            'mdi': Boolean(iNavItem.subMenu),
            'mdi-chevron-up': Boolean(iNavItem.active && iNavItem.subMenu),
            'mdi-chevron-down': Boolean(!iNavItem.active && iNavItem.subMenu),
            displaynone: this.getDispNone(),
        };
    }
    getiNavLineClass(iActive, iNavItem) {
        return {
            lineitem: true,
            hide: !iActive,
            activeItemBgColor: iNavItem.itemSelected,
            clickedMenuBgColor: iNavItem.clicked === true,
            activeMenuBgColor: iNavItem.selectedMenu,
            subMenu: Boolean(iNavItem.isSubMenu),
            bottomBorder: Boolean(iNavItem.bottomBorder),
            markedBottomBorder: Boolean(iNavItem.markedBottomBorder),
            activeBottomBorder: Boolean(iNavItem.activeBottomBorder)
        };
    }
    getBottomBtnClass() {
        return {
            menuOpen: true
        };
    }
    handleMouseOver() {
        this.isVisible = true;
        this.requestUpdate();
    }
    handleMouseOut() {
        this.isVisible = false || PIC.getInstance.userConfig.isNavDrawerPinned;
        this.requestUpdate();
    }
    updateBodyStyle() {
        let outerBody = document.querySelector('.pic-bodycontainer');
        if (outerBody) {
            if (PIC.getInstance.userConfig.isNavDrawerPinned)
                outerBody.setAttribute('style', 'grid-template-columns: 250px 6fr;');
            else
                outerBody.setAttribute('style', '');
        }
        this.requestUpdate();
    }
    handleClick() {
        PIC.getInstance.userConfig.isNavDrawerPinned = !PIC.getInstance.userConfig.isNavDrawerPinned;
        this.isVisible = PIC.getInstance.userConfig.isNavDrawerPinned;
        this.updateBodyStyle();
        let modals = PIC.getInstance.events.openModals;
        if (modals.length > 0)
            modals.forEach((modal) => modal.handleNavPinning());
    }
    renderListData(iData, iLevel, iActive) {
        let activeItem = sessionStorage.getItem(this.ACTIVE_ITEM);
        if (iData)
            return html `${iData.map((x) => this.renderListItem(x, iLevel, iActive, activeItem))}`;
        return html ``;
    }
    getElementId(iNavItem) {
        if (iNavItem.isTopLevel) {
            return `lineItem-${(iNavItem.navText.toLowerCase().replace(/ /gm, '').replace(/&/gm, 'and')).replace(/[^0-9a-zA-Z-_]/g, '')}`;
        }
        else {
            return `lineItem-subMenu-${(iNavItem.navText.toLowerCase().replace(/ /gm, '').replace(/&/gm, 'and')).replace(/[^0-9a-zA-Z-_]/g, '')}`;
        }
    }
    clickHandler(e, iNavItem) {
        var _a;
        let item = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(`#${this.getElementId(iNavItem)}`);
        if (iNavItem.subMenu) {
            this.expandAction(e, iNavItem);
            iNavItem.clicked = true;
            // adds and removes clickedBgColor on open/close
            if (iNavItem.active) {
                iNavItem.clicked = true;
            }
            else {
                iNavItem.clicked = false;
            }
        }
        // If item has className 'subMenu' and does not have subMenu -> make item active and highlighted + store in activeItem
        if ((item === null || item === void 0 ? void 0 : item.id.includes('subMenu')) && !iNavItem.subMenu) {
            this.clickAction(e, iNavItem);
            sessionStorage.setItem(this.ACTIVE_ITEM, this.getElementId(iNavItem));
        }
        // If iNavItem does not have submenu, do something (has nothing to do with submenu items)
        else if (!iNavItem.subMenu) {
            this.clickAction(e, iNavItem);
            iNavItem.itemSelected = true;
            sessionStorage.clear();
            sessionStorage.setItem(this.ACTIVE_ITEM, this.getElementId(iNavItem));
        }
    }
    handleBottomLine(iNavItem, activeItem) {
        var _a, _b;
        // add a bigger border to active item
        if (activeItem === this.getElementId(iNavItem) && iNavItem.markedBottomBorder !== true) {
            iNavItem.activeBottomBorder = true;
        }
        // add border to the last item in a subMenu (if that item does not have a subMenu) ???? 
        if (iNavItem.subMenu && iNavItem.subMenu[0].subMenu === undefined) {
            if ((_a = iNavItem.subMenu) === null || _a === void 0 ? void 0 : _a.slice(-1)) {
                iNavItem.subMenu.slice(-1)[0].bottomBorder = true;
                iNavItem.subMenu.slice(-1)[0].activeBottomBorder = false;
            }
        }
        // removes bottomborder from active subMenu that is also isSubMenu
        if (iNavItem.subMenu && iNavItem.active === true) {
            iNavItem.bottomBorder = false;
        }
        // keep a bigger bottomBorder in the bottom of all subMenus (also when a subMenu is active)
        if (iNavItem.isTopLevel) { // Ensures that only the last and last of last items get bigger bottomLine
            if (iNavItem.subMenu) {
                let lastSubMenuItem = iNavItem.subMenu[iNavItem.subMenu.length - 1];
                if (lastSubMenuItem.active === true) {
                    lastSubMenuItem.markedBottomBorder = false;
                }
                else if (lastSubMenuItem.active === false) {
                    lastSubMenuItem.markedBottomBorder = true;
                    lastSubMenuItem.bottomBorder = false;
                }
                if (lastSubMenuItem.subMenu) {
                    let lastOfLast = lastSubMenuItem.subMenu[((_b = lastSubMenuItem.subMenu) === null || _b === void 0 ? void 0 : _b.length) - 1];
                    lastOfLast.markedBottomBorder = true;
                    lastOfLast.bottomBorder = false;
                }
            }
        }
    }
    setSubMenuClass(iNavItem) {
        var _a;
        // all items always has className 'subMenu' 
        (_a = iNavItem.subMenu) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
            item.isSubMenu = true;
        });
    }
    renderListItem(iNavItem, iLevel, iActive, activeItem) {
        this.setSubMenuClass(iNavItem);
        this.handleBottomLine(iNavItem, activeItem);
        return html `
            <div 
                @mouseenter=${enableTT} 
                @mouseleave=${disableTT} 
                class=${classMap(this.getiNavLineClass(iActive, iNavItem))} 
                @click=${(e) => this.clickHandler(e, iNavItem)}
                id=${this.getElementId(iNavItem)}
                title=${iNavItem.navText}
                .level=${iLevel}
            >
                <i class=${/^mdi-/.test(iNavItem.iconClass) ? 'mdi menuIcons ' + iNavItem.iconClass : ' fa fa-2x menuIcons ' + iNavItem.iconClass}></i>
                <span class=${classMap(this.getTextClass())}>
                    ${iNavItem.navText}
                </span>
                
                <i class=${classMap(this.getMenuIconClass(iNavItem))}></i>
            </div>
            ${iNavItem.subMenu ? html `${this.renderListData(iNavItem.subMenu, iLevel + 1, iNavItem.active)}` : ''}
        `;
        function enableTT() {
            iNavItem.hovered = true;
            iNavItem.focused = true;
        }
        function disableTT() {
            iNavItem.hovered = false;
            iNavItem.focused = false;
        }
    }
    clickAction(e, iNavItem) {
        iNavItem.active;
        doSubmit(iNavItem.navEvent);
    }
    expandAction(e, iNavItem) {
        iNavItem.active = !iNavItem.active;
        if (!iNavItem.active && iNavItem.subMenu) {
            this.disableChildren(iNavItem);
        }
        e.stopImmediatePropagation();
        e.preventDefault();
        this.requestUpdate();
    }
    toggleSettings() {
        let settings = document.querySelector("pic-config");
        let help = document.querySelector('pic-help');
        if (settings) {
            settings.remove();
        }
        if (!settings) {
            settings = document.createElement("pic-config");
            document.body.appendChild(settings);
            if (help) {
                help.remove();
            }
        }
        let picconfig = settings;
        if (picconfig) {
            picconfig.isHidden = !picconfig.isHidden;
            picconfig.requestUpdate();
        }
    }
    toggleHelp() {
        var _a;
        let help = document.querySelector('pic-help');
        let settings = document.querySelector("pic-config");
        let hiddenModal = (_a = help === null || help === void 0 ? void 0 : help.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('pic-modal');
        if (hiddenModal) {
            if (hiddenModal.isHidden) {
                window.addEventListener('keydown', hiddenModal.handleKeys);
            }
            else {
                window.removeEventListener('keydown', hiddenModal.handleKeys);
            }
        }
        if (!help) {
            help = document.createElement('pic-help');
            document.body.appendChild(help);
            if (settings) {
                settings.remove();
            }
        }
        help.isHidden = !help.isHidden;
    }
    disableChildren(iNavItem) {
        var _a;
        iNavItem.active = false;
        (_a = iNavItem.subMenu) === null || _a === void 0 ? void 0 : _a.forEach(ni => this.disableChildren(ni));
    }
    firstUpdated(_changedProperties) {
        let ref = this;
        setTimeout(() => {
            var _a;
            if (this.navGroup) {
                fetchRestApi(null, {
                    httpMethod: 'GET',
                    path: `menu?groupId=${this.navGroup}&getAsNav=true`,
                    picsystem: PIC.systemId
                }).then(res => res.json())
                    .then(json => {
                    var _a;
                    this.data = json;
                    (_a = this.data) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                        item.isTopLevel = true;
                    });
                    this.dispatchEvent(new CustomEvent('DrawerDataLoaded'));
                });
            }
            else {
                this.data = ref.parseDrawerData(ref.childNodes, ref);
                this.dispatchEvent(new CustomEvent('DrawerDataLoaded'));
                (_a = this.data) === null || _a === void 0 ? void 0 : _a.forEach((item) => {
                    item.isTopLevel = true;
                });
                let that = this;
                //given a child element, return it and all parents
                function fullPath(data, id, path) {
                    for (let node of data) {
                        path.push(node);
                        if (id === that.getElementId(node))
                            return node;
                        if (node.subMenu) {
                            let myNode = fullPath(node.subMenu, id, path);
                            if (myNode) {
                                return myNode;
                            }
                            else
                                path.pop(); //removes wrong sub nodes
                        }
                        else {
                            path.pop(); //removes wrong end nodes
                        }
                    }
                    return false;
                }
                if (this.data) {
                    let menuArray = [];
                    let selectedElement = sessionStorage.getItem(this.ACTIVE_ITEM);
                    if (selectedElement !== null) {
                        let x = fullPath(this.data, selectedElement, menuArray);
                        // why if menuArray is longer than 0?? 
                        // If menu contains more that one element -> 
                        // check if array contains elements 
                        if (menuArray.length > 0) {
                            // Adds activeBgColor to TopMenuLvl when any child elements are active
                            // active element with parents  
                            if (menuArray.length > 1 && menuArray[0]) {
                                menuArray[0].selectedMenu = true;
                            }
                            // keeps menus open ande correctly colored on refresh
                            menuArray.forEach((e) => {
                                e.clicked = true;
                                e.active = true;
                                // if selected item -> add selectedBgColor
                                if (selectedElement === this.getElementId(e)) {
                                    e.itemSelected = true;
                                    e.clicked = false;
                                }
                            });
                            // adds activeBgColor to menuHeader of active item
                            let menuHeader = menuArray.length - 2;
                            if (menuArray[menuHeader]) {
                                menuArray[menuHeader].selectedMenu = true;
                                menuArray[menuHeader].clicked = false;
                            }
                        }
                    }
                }
            }
        }, 20);
        this.updateBodyStyle();
    }
    setUserConfigAndUpdateStyle(e) {
        var _a;
        let userConfigState = PIC.getInstance.userConfig.hasUpdated();
        if (userConfigState.updated) {
            this.updateBodyStyle();
        }
        else {
            (_a = userConfigState.promise) === null || _a === void 0 ? void 0 : _a.then(() => {
                this.updateBodyStyle();
            });
        }
        this.requestUpdate();
    }
    parseDrawerData(iNodes, iRef) {
        let res = [];
        for (let dd of iNodes) {
            if (dd.nodeName == 'DRAWER-DATA') {
                let tmp = {
                    navText: dd.getAttribute('menutext'),
                    navEvent: dd.getAttribute('menuevent'),
                    iconClass: dd.getAttribute('menuicon'),
                    subMenu: this.parseDrawerData(dd.childNodes, iRef),
                    active: false,
                    hovered: false,
                    focused: false,
                    // topSelected: false,
                    // subMenuSelected: false,
                    selectedMenu: false,
                    itemSelected: false
                };
                if (!tmp.iconClass)
                    tmp.iconClass = 'fa-' + tmp.navText.substring(0, 1).toLowerCase();
                res.push(tmp);
            }
        }
        if (res.length != 0)
            return res;
        return undefined;
    }
    renderIcon() {
        if (this.bigIconPath_)
            return html `<img style="height:100%;" src="${this.isVisible ? this.bigIconPath_ : this.smallIconPath_ ? this.smallIconPath_ : this.bigIconPath_}">`;
        else
            return this.isVisible ? this.renderPICitLogo() : this.renderPICitDots('2.0');
    }
    renderBottom() {
        return html `
            <div class="lineitem bottom">
                <div class="help bottomBtn" @click=${() => this.toggleHelp()}>
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.22949 16H11.2295V14H9.22949V16ZM10.2295 0C4.70949 0 0.229492 4.48 0.229492 10C0.229492 15.52 4.70949 20 10.2295 20C15.7495 20 20.2295 15.52 20.2295 10C20.2295 4.48 15.7495 0 10.2295 0ZM10.2295 18C5.81949 18 2.22949 14.41 2.22949 10C2.22949 5.59 5.81949 2 10.2295 2C14.6395 2 18.2295 5.59 18.2295 10C18.2295 14.41 14.6395 18 10.2295 18ZM10.2295 4C8.01949 4 6.22949 5.79 6.22949 8H8.22949C8.22949 6.9 9.12949 6 10.2295 6C11.3295 6 12.2295 6.9 12.2295 8C12.2295 10 9.22949 9.75 9.22949 13H11.2295C11.2295 10.75 14.2295 10.5 14.2295 8C14.2295 5.79 12.4395 4 10.2295 4Z" fill="black" fill-opacity="0.6"/>
                    </svg>  
                </div>
                <div class="settings bottomBtn ${this.getDispNone() ? 'displaynone' : ''}" @click=${() => this.toggleSettings()}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.3525 10.936C17.3885 10.636 17.4125 10.324 17.4125 10C17.4125 9.67602 17.3885 9.36402 17.3405 9.06402L19.3685 7.48002C19.5485 7.33602 19.5965 7.07202 19.4885 6.86802L17.5685 3.54402C17.4485 3.32802 17.1965 3.25602 16.9805 3.32802L14.5925 4.28802C14.0885 3.90402 13.5605 3.59202 12.9725 3.35202L12.6125 0.808024C12.5765 0.568024 12.3725 0.400024 12.1325 0.400024H8.29251C8.05251 0.400024 7.86051 0.568024 7.82451 0.808024L7.46451 3.35202C6.87651 3.59202 6.33651 3.91602 5.84451 4.28802L3.45651 3.32802C3.24051 3.24402 2.98851 3.32802 2.86851 3.54402L0.948509 6.86802C0.828509 7.08402 0.876509 7.33602 1.06851 7.48002L3.09651 9.06402C3.04851 9.36402 3.01251 9.68802 3.01251 10C3.01251 10.312 3.03651 10.636 3.08451 10.936L1.05651 12.52C0.876509 12.664 0.828509 12.928 0.936509 13.132L2.85651 16.456C2.97651 16.672 3.22851 16.744 3.44451 16.672L5.83251 15.712C6.33651 16.096 6.86451 16.408 7.45251 16.648L7.81251 19.192C7.86051 19.432 8.05251 19.6 8.29251 19.6H12.1325C12.3725 19.6 12.5765 19.432 12.6005 19.192L12.9605 16.648C13.5485 16.408 14.0885 16.084 14.5805 15.712L16.9685 16.672C17.1845 16.756 17.4365 16.672 17.5565 16.456L19.4765 13.132C19.5965 12.916 19.5485 12.664 19.3565 12.52L17.3525 10.936ZM10.2125 13.6C8.23251 13.6 6.61251 11.98 6.61251 10C6.61251 8.02002 8.23251 6.40002 10.2125 6.40002C12.1925 6.40002 13.8125 8.02002 13.8125 10C13.8125 11.98 12.1925 13.6 10.2125 13.6Z" fill="black" fill-opacity="0.6"/>
                    </svg>
                </div>
                <div class="logout bottomBtn ${this.getDispNone() ? 'displaynone' : ''}" @click=${() => doSubmit('Exit')}>
                    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16.2139 17.0156V14.0156H9.22949V9.98438H16.2139V6.98438L21.2295 12L16.2139 17.0156ZM14.2451 2.01562C14.7764 2.01562 15.2295 2.21875 15.6045 2.625C16.0107 3 16.2139 3.45312 16.2139 3.98438V6H14.2451V3.98438H5.24512V20.0156H14.2451V18H16.2139V20.0156C16.2139 20.5469 16.0107 21 15.6045 21.375C15.2295 21.7812 14.7764 21.9844 14.2451 21.9844H5.24512C4.68262 21.9844 4.19824 21.7812 3.79199 21.375C3.41699 21 3.22949 20.5469 3.22949 20.0156V3.98438C3.22949 3.45312 3.41699 3 3.79199 2.625C4.19824 2.21875 4.68262 2.01562 5.24512 2.01562H14.2451Z" fill="black" fill-opacity="0.6"/>
                    </svg>
                </div>
            </div>
        `;
    }
    renderPICitLogo() {
        return html `
            <svg xmlns="http://www.w3.org/2000/svg" id="PICitLogo" width="165" height="120" viewBox="0 0 175 80" version="1.1" style="padding-left: 5px;padding-right: 5px;">
                <g id="main" transform="scale(2)">
                    <g id="PiC_group" fill="#485355">
                        <path id="p" d="M 1,0 h 16 s 1,0 1,1 v 26 s 0,1 -1,1 h -9 v -8 h 2 v -12 h -2 v 29 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -36 s 0,-1 1,-1 z"/>
                        <path id="top_i1" d="M 21,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                        <path id="bottom_i1" d="M 21,10 h 6 s 1,0 1,1 v 26 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -26 s 0,-1 1,-1 z"/>
                        <path id="c" d="M 30,0 h 16 s 1,0 1,1 v 16 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -9 h -2 v 22 h 2 v -9 s 0,-1 1,-1 h 6 s 1,0 1,1 v 16 s 0,1 -1,1 h -15 s -1,0 -1,-1 v -36 s 0,-1 1,-1 z"/>
                    </g>
                    <g id="square_group">
                        <path id="redsquare" fill="#DD1A22" d="M 50,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                        <path id="yellowsquare" fill="#FFD900" d="M 50,10 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                        <path id="greensqaure" fill="#4BAE44" d="M 50,20 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                        <path id="bluesquare" fill="#017CB8" d="M 50,30 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                    </g>
                    <g id="it_group" fill="#737E84">
                        <path id="top_i2" d="M 60,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "/>
                        <path id="bottom_i2" d="M 60,10 h 6 s 1,0 1,1 v 26 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -26 s 0,-1 1,-1 z"/>
                        <path id="t" d="M 70,0 h 6 s 1,0 1,1 v 9 h 9 s 1,0 1,1 v 6 s 0,1 -1,1 h -9 v 12 h 2 v -9 s 0,-1 1,-1 h 6 s 1,0 1,1 v 16 s 0,1 -1,1 h -16 s -1,0 -1,-1 v -36 s 0,-1 1,-1 z"/>
                    </g>
                    <g id="trademark_group" fill="#737E84">
                    <circle id="circle" r="2" cy="2.25" cx="81.5" fill="none" stroke="#737E84" stroke-width="0.5" />
                    <path id="trademark_r" d="M 81.4,2.1 c 0.13,0.0 0.30,-0.03 0.34,-0.18 0.04,-0.13 0.03,-0.32 -0.12,-0.39 -0.15,-0.06 -0.31,-0.032 -0.47,-0.039 -0.02,0.02 -0.0,0.07 -0.0,0.11 0,0.17 0,0.33 0,0.50 0.09,0 0.17,0 0.26,0 z m -0.26,0.42 c 0,0.30 0,0.59 0,0.89 -0.20,0 -0.40,0 -0.61,0 0,-0.78 0,-1.57 0,-2.35 0.35,0.0 0.7,-0.0 1.05,0.0 0.24,0.01 0.51,0.06 0.67,0.27 0.12,0.18 0.13,0.41 0.07,0.61 -0.06,0.19 -0.23,0.32 -0.42,0.37 0.23,0.05 0.35,0.27 0.44,0.47 0.1,0.21 0.21,0.42 0.31,0.63 -0.22,0 -0.43,0 -0.65,0 -0.11,-0.23 -0.22,-0.46 -0.34,-0.68 -0.06,-0.12 -0.19,-0.21 -0.32,-0.21 -0.07,-0.0 -0.14,0.0 -0.21,0.0 z" />
                </g>
            </g>
        </svg>
        `;
    }
    renderPICitDots(scale) {
        return html `
            <div class=${classMap({ 'picitDots': !scale, 'picitDotsBig': scale !== null && scale !== void 0 ? scale : false })}>
                <svg xmlns="http://www.w3.org/2000/svg" id="PICitLogo" width="8" height="38" version="1.1">
                    <g id="square_group" transform=scale(${scale ? scale : 1.0})>
                        <path id="redsquare" fill="#E81D2B" d="M 0,0 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "></path>
                        <path id="yellowsquare" fill="#FFD939" d="M 0,10 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "></path>
                        <path id="greensqaure" fill="#37AD4C" d="M 0,20 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "></path>
                        <path id="bluesquare" fill="#007CB4" d="M 0,30 h 6 s 1,0 1,1 v 6 s 0,1 -1,1 h -6 s -1,0 -1,-1 v -6 s 0,-1 1,-1 z "></path>
                    </g>
                </svg>
            </div>
        `;
    }
    renderBackBtn() {
        if (!this.backBtnItem)
            return html ``;
        return html `
            <div class="back-button-container" title=${this.backBtnItem.navText}
                 @click=${(e) => this.clickHandler(e, this.backBtnItem)}>
                <i class="mdi mdi-keyboard-backspace"></i>
            </div>
        `;
    }
    render() {
        return html `
            ${this.renderCSS(true)}
            <nav class=${classMap(this.getMainMenuClass())}
                @mouseover=${this.handleMouseOver}
                @mouseleave=${this.handleMouseOut}
            >
                <div class="top_row lineitem">
                    ${this.renderBackBtn()}
                    <span class=${classMap(this.getTextClass())}>${this.user_}</span>
                    <i  class=${classMap(this.getPinClass())} 
                        @click=${this.handleClick}>
                    </i>
                </div>
                <div class="top_buttons">
                    ${this.renderListData(this.data, 0, true)}
                    <div class=${classMap(this.getMenuBottomLineClass())}></div>
                </div>
                <div class="logo_container">
                    ${this.renderIcon()}
                </div>
                <div class="bottom_buttons">
                    ${this.renderBottom()}
                </div>
                ${this.disabled_ ? html `
                    <div id="navBlocker"
                        class=${this.isVisible ? 'wide' : ''}>
                    </div>
                ` : ''}
            </nav>
        `;
    }
};
__decorate([
    property({ attribute: 'isVisible', converter: stringDecoder })
], PICNavDrawer.prototype, "isVisible", void 0);
__decorate([
    property({ attribute: 'backbtn', converter: booleanDecoder })
], PICNavDrawer.prototype, "backBtn", void 0);
__decorate([
    property({ attribute: 'user', converter: stringDecoder })
], PICNavDrawer.prototype, "user_", void 0);
__decorate([
    property({ attribute: 'navid', converter: stringDecoder })
], PICNavDrawer.prototype, "navid_", void 0);
__decorate([
    property({ attribute: 'iconpath', converter: stringDecoder })
], PICNavDrawer.prototype, "iconPath_", void 0);
__decorate([
    property({ attribute: 'bigiconpath', converter: stringDecoder })
], PICNavDrawer.prototype, "bigIconPath_", void 0);
__decorate([
    property({ attribute: 'smalliconpath', converter: stringDecoder })
], PICNavDrawer.prototype, "smallIconPath_", void 0);
__decorate([
    property({ attribute: 'navgroup', reflect: false })
], PICNavDrawer.prototype, "navGroup", void 0);
PICNavDrawer = __decorate([
    customElement('pic-navdrawer')
], PICNavDrawer);
export { PICNavDrawer };
//# sourceMappingURL=PICNavDrawer.js.map